// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Col, DatePicker, Form, Row } from "antd";
import { dateTimeFormat } from "../../../../utils/Constant";
import locale from "antd/es/date-picker/locale/fr_FR";
import moment from "moment";
import { SurveyFormSectionProps } from "../../../types/SurveyTypes";

const SurveyDateFormSection: React.FunctionComponent<SurveyFormSectionProps> = (
  props: SurveyFormSectionProps
) => {
  const { t } = useTranslation();

  const { editMode, survey } = props;

  const [scheduledAvailabilityDate, setScheduledAvailabilityDate] = useState(
    survey?.scheduledAvailabilityDate
  );

  const [
    scheduledAvailabilityEndDate,
    setScheduledAvailabilityEndDate
  ] = useState(survey?.scheduledAvailabilityEndDate);

  const [
    scheduledResultAvailabilityDate,
    setScheduledResultAvailabilityDate
  ] = useState(survey?.scheduledResultAvailabilityDate);

  const [scheduledVoteCloseDate, setScheduledVoteCloseDate] = useState(
    survey?.scheduledVoteCloseDate
  );

  const initialScheduledAvailabilityDate = survey?.scheduledAvailabilityDate
    ? moment(survey?.scheduledAvailabilityDate)
    : undefined;

  const initialScheduledAvailabilityEndDate = survey?.scheduledAvailabilityEndDate
    ? moment(survey?.scheduledAvailabilityEndDate)
    : undefined;

  const initialScheduledResultAvailabilityDate = survey?.scheduledResultAvailabilityDate
    ? moment(survey?.scheduledResultAvailabilityDate)
    : undefined;

  const initialScheduledVoteEndDate = survey?.scheduledVoteCloseDate
    ? moment(survey?.scheduledVoteCloseDate)
    : undefined;

  return (
    <>
      <Row>
        <Col xs={24} sm={12}>
          <Form.Item
            name="scheduledAvailabilityDate"
            key="scheduledAvailabilityDate"
            label={<span>{t("survey.scheduled_availability_date")}</span>}
            initialValue={initialScheduledAvailabilityDate}
          >
            <DatePicker
              disabled={!editMode}
              locale={locale}
              id="scheduledAvailabilityDate"
              disabledDate={d =>
                !d ||
                (!!scheduledAvailabilityEndDate &&
                  d.isAfter(scheduledAvailabilityEndDate, "minute")) ||
                (!!scheduledResultAvailabilityDate &&
                  d.isAfter(scheduledResultAvailabilityDate, "minute")) ||
                (!!scheduledVoteCloseDate &&
                  d.isAfter(scheduledVoteCloseDate, "minute"))
              }
              showTime
              format={dateTimeFormat}
              onChange={(value: any) => setScheduledAvailabilityDate(value)}
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="scheduledAvailabilityEndDate"
            initialValue={initialScheduledAvailabilityEndDate}
            label={<span>{t("survey.scheduled_availability_end_date")}</span>}
          >
            <DatePicker
              disabled={!editMode}
              locale={locale}
              id="scheduledAvailabilityEndDate"
              disabledDate={d =>
                !d ||
                (!!scheduledAvailabilityDate &&
                  d.isBefore(scheduledAvailabilityDate, "minute"))
              }
              showTime
              format={dateTimeFormat}
              onChange={(value: any) => setScheduledAvailabilityEndDate(value)}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24} sm={12}>
          <Form.Item
            name="scheduledResultAvailabilityDate"
            initialValue={initialScheduledResultAvailabilityDate}
            label={
              <span>{t("survey.scheduled_result_availability_date")}</span>
            }
          >
            <DatePicker
              disabled={!editMode}
              locale={locale}
              id="scheduledResultAvailabilityDate"
              disabledDate={d =>
                !d ||
                (!!scheduledAvailabilityDate &&
                  d.isBefore(scheduledAvailabilityDate, "minute"))
              }
              showTime
              format={dateTimeFormat}
              onChange={(value: any) =>
                setScheduledResultAvailabilityDate(value)
              }
            />
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}>
          <Form.Item
            name="scheduledVoteCloseDate"
            key="scheduledVoteCloseDate"
            label={<span>{t("survey.scheduled_vote_close_date")}</span>}
            initialValue={initialScheduledVoteEndDate}
          >
            <DatePicker
              disabled={!editMode}
              locale={locale}
              id="scheduledVoteCloseDate"
              disabledDate={d =>
                !d ||
                (!!scheduledAvailabilityDate &&
                  d.isBefore(scheduledAvailabilityDate, "minute"))
              }
              showTime
              format={dateTimeFormat}
              onChange={(value: any) => setScheduledVoteCloseDate(value)}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default SurveyDateFormSection;
